<form class="verify__email mt-6" (submit)="submit()">
  <div class="verify__pin flex justify-center gap-6">
    <input
      type="text"
      [ngClass]="{ invalid: form.invalid && isShowErrors }"
      [formControl]="form.controls.c1"
      #box1Input
      (input)="onInput($event, 0)"
      (keydown)="onKeyDown($event, 0)"
      autocomplete="new-password"
    />
    <input
      type="text"
      [ngClass]="{ invalid: form.invalid && isShowErrors }"
      [formControl]="form.controls.c2"
      #box2Input
      (input)="onInput($event, 1)"
      (keydown)="onKeyDown($event, 1)"
      autocomplete="new-password"
    />
    <input
      type="text"
      [ngClass]="{ invalid: form.invalid && isShowErrors }"
      [formControl]="form.controls.c3"
      #box3Input
      (input)="onInput($event, 2)"
      (keydown)="onKeyDown($event, 2)"
      autocomplete="new-password"
    />
    <input
      type="text"
      [ngClass]="{ invalid: form.invalid && isShowErrors }"
      [formControl]="form.controls.c4"
      #box4Input
      (input)="onInput($event, 3)"
      (keydown)="onKeyDown($event, 3)"
      autocomplete="new-password"
    />
  </div>
  @if (isShowErrors) {
    <span
      class="text-red-500 block text-center mt-2"
      *ngIf="form.controls.fullCode?.errors?.['required']"  translate="This field is required"
      > </span
    >

    <span
      class="text-red-500 block text-center mt-2"
      *ngIf="!form.controls.fullCode?.errors?.['required'] && form.invalid"
       translate="Verification code is invalid"
      ></span
    >
  }

  <button class="primary__btn w-full mt-6" translate="Verify"></button>
  @if (allowResend) {
    <button
      type="button"
      class="resend__email mt-4"
      *ngIf="allowResend"
      (click)="resendCode()"
      translate="Resend Email"
    >
      
    </button>
  } @else {
    <span
      class="resend__email_trimer mt-4"
      [dateCountDown]="timerTo"
      (onTimesUp)="allowResend = true"
    ></span>
  }
</form>
